export default class EventsMap {
    constructor() {
        this.useRestAPI = true;
        this.container_id = 'events-map';
        this.data_container = 'tribe-events-view-data';
        this.init();
    }

    init() {
        this.initContainer();
        if(!this.container) return;
        this.initData();
        this.initMap();
        this.initListeners();
        this.initJcf();
    }

    initContainer() {
        this.container = document.getElementById(this.container_id);
    }

    initJcf() {
        jcf.replace('#tribe-events-categories', 'Select', {
            wrapNative: false
        });
    }

    initMap() {
        this.map = new google.maps.Map(this.container, {
            center: {lat: 38, lng: -100},
            zoom: 4,
            styles: this.styles
        });
        this.bounds = new google.maps.LatLngBounds();
        this.fetchEvents().then(result => {
            this.markers = [];
            $.each(result, (key, item) => this.addMarker(key, item));
            this.cluster = new MarkerClusterer(this.map, this.markers,
                {imagePath: base.ajax_url + '?action=pin&fill=F15B56&'});
            // if(this.markers.length) this.map.fitBounds(this.bounds);
        });
    }

    addMarker(key, item) {
        if(!item.acf.location) return;
        let infoWindow = new google.maps.InfoWindow({
            content: this.templateInfoWindow(item)
        });
        let position = {lat: item.acf.location.lat, lng: item.acf.location.lng};
        let marker = new google.maps.Marker({
            position: position,
            map: this.map,
            title: 'Title',
            icon: {
                url: base.ajax_url + '?action=pin&fill=' + base.tribe_categories_colors[item.tribe_events_cat[0]],
                size: new google.maps.Size(50, 50),
            }
        });
        this.bounds.extend(position);
        marker.addListener('click', () => infoWindow.open(this.map, marker));
        this.markers.push(marker);
    }

    initListeners() {
        $('body').on('afterAjaxSuccess.tribeEvents', '.tribe-events', event => this.ajaxComplete());
        $('body').on('change', '#tribe-events-categories', event => this.filterByCategory(event));
    }

    initData() {
        this.data = JSON.parse($("[data-js='" + this.data_container + "']").text());
    }

    filterByCategory(event) {
        $("[class*='tribe-events-cat-']").show(0);
        $("[class*='tribe-events-cat-']:not([class*='tribe-events-cat-" + $(event.target).val() + "'])").hide(0);
    }

    templateInfoWindow(item) {
        return '<div class="marker-info-window">'
                + '<h2>' + item.title.rendered + '</h2>'
                + '<p>' + item.acf.location.address + '</p>'
                + '<a href="' + item.link + '">' + 'Event Details' + '</a>'
            + '</div>';
    }

    fetchEvents() {
        if(this.useRestAPI) {
            return this.fetchEventsFromRestAPI();
        } else {
            return this.fetchEventsFromTribesData();
        }
    }

    fetchEventsFromTribesData() {
        return new Promise((resolve) => {
            resolve(JSON.parse($('[type="application/ld+json"]').text()));
        });
    }

    fetchEventsFromRestAPI() {
        return new Promise((resolve) => {
            $.ajax({
                url: '/wp-json/wp/v2/tribe_events/',
                dataType: 'json',
                success: (result) => {
                    resolve(result);
                }
            });
        });
    }

    ajaxComplete() {
        this.initContainer();
        this.initData();
        this.initMap();
        this.initJcf();
    }

    get styles() {
        return [
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#bdbdbd"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dadada"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#c9c9c9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            }
        ];
    }
}